import img from '../../../img/desert5.svg'
import img2 from '../../../img/desert6.svg'
import img3 from '../../../img/desert7.svg'
import img4 from '../../../img/desert8.svg'
import img5 from '../../../img/desert9.svg'
import img6 from '../../../img/desert10.svg'



export const desertData = [
    {
        img: img,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '395 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'desert#1'
    },
    {
        img: img2,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '395 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id:'desert#2'
    },
    {
        img: img3,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '395 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'desert#3'
    },
    {
        img: img4,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '395 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'desert#4'
    },
    {
        img: img4,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '395 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'desert#5'
    },
    {
        img: img5,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '395 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'desert#7'
    },
    {
        img: img6,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '395 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id:'desert#8'
    },
    {
        img: img3,
        name: 'Филадельфия крем-брюле',
        text: 'Сливочный сыр, семга татаки с тростниковым сахаром, соус у...',
        price: '395 ₽',
        size: '20',
        quality: 'Thin',
        isMonzarella: true,
        isChampignons: false,
        isOnion: false,
        isSweet: false,
        count: 1,
        id: 'desert#9'
    },


]